import React, { useRef, useEffect, useState } from 'react';
import shortid from 'shortid';
import axios from 'axios';
import QuillLib from 'quill';
import ImageUploader from 'quill-image-uploader';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCode } from '@fortawesome/free-solid-svg-icons/faCode';

import { VideoBlot, AudioBlot, YoutubeBlot } from './formats';
import {
  BtnYoutube,
  BtnVideo,
  BtnAudio,
  BtnsHistory,
} from './btns';

QuillLib.register(VideoBlot);
QuillLib.register(AudioBlot);
QuillLib.register(YoutubeBlot);
QuillLib.register('modules/imageUploader', ImageUploader);

const Quill = ({
  className = '',
  placeholder = '',
  value = '',
  fileUploadUrl,
  onBlur = () => {},
  onChange = () => {},
}) => {
  const el = useRef();
  const editor = useRef();
  const [sourceMode, setSourceMode] = useState(false);
  const [toolbarId] = useState(() => `a${shortid.generate()}`);

  useEffect(() => {
    const quill = new QuillLib(el.current, {
      theme: 'snow',
      placeholder,
      modules: {
        toolbar: {
          container: `#${toolbarId}`,
        },
        history: {
          userOnly: true,
        },
        imageUploader: {
          async upload(file) {
            const fd = new FormData();

            fd.append('file', file);

            const { data } = await axios.post(fileUploadUrl, fd);

            return data.url;
          },
        },
      },

    });

    // onBlur event
    quill.on('selection-change', (range) => {
      if (!range) onBlur();
    });

    // onChange event
    quill.on(
      'text-change',
      () => onChange(quill.root.innerHTML),
    );

    // insert value
    quill.root.innerHTML = value;

    // store ref
    editor.current = quill;
  }, [toolbarId]);

  return (
    <div
      {...{
        className: ['quill', className].filter((s) => s).join(' '),
      }}
    >
      <div className={sourceMode ? 'd-none' : ''}>
        <div id={toolbarId} className="pos-sticky">
          <span className="ql-formats">
            <button className="ql-bold"></button>
            <button className="ql-italic"></button>
            <button className="ql-underline"></button>
            <button className="ql-strike"></button>
            <button className="ql-blockquote"></button>
            <button className="ql-clean"></button>
          </span>
          <span className="ql-formats">
            <select className="ql-header" defaultValue=''>
              <option value="1" />
              <option value="2" />
              <option />
            </select>
          </span>
          <span className="ql-formats">
            <button className="ql-list" value="ordered"></button>
            <button className="ql-list" value="bullet"></button>
            <button className="ql-indent" value="-1"></button>
            <button className="ql-indent" value="+1"></button>
          </span>
          <span className="ql-formats">
            <select className="ql-align"></select>
            <select className="ql-color"></select>
            <select className="ql-background"></select>
          </span>
          <span className="ql-formats">
            <button className="ql-link"></button>
            <button className="ql-image"></button>
            <BtnVideo
              editor={editor.current}
              fileUploadUrl={fileUploadUrl}
            />
            <BtnAudio
              editor={editor.current}
              fileUploadUrl={fileUploadUrl}
            />
            <BtnYoutube
              editor={editor.current}
            />
          </span>
          <span className="ql-formats">
            <button
              type="button"
              onClick={() => setSourceMode(true)}
            >
              <FA icon={faCode} size="xs" />
            </button>
            <BtnsHistory editor={editor.current} />
          </span>
        </div>
        <div ref={el}></div>
      </div>

      {sourceMode && (
        <div>
          <div className="border-bottom">
            <button
              className="btn-link btn sm"
              onClick={() => {
                editor.current.root.innerHTML = value;
                setSourceMode(false);
              }}
            >
              <small><strong>HTML</strong></small>
            </button>
          </div>
          <textarea
            className="ql-source-editor"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          ></textarea>
        </div>
      )}
    </div>
  );
};

export default Quill;
